
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/collections/[id]",
      function () {
        return require("private-next-pages/help/collections/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/collections/[id]"])
      });
    }
  